import React from 'react';
import { fundingStreams } from '../mock';

const FundingStreams = () => {
  return (
    <section className="py-16 lg:py-24 bg-neutral-50">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="grid lg:grid-cols-[420px_1fr] gap-14">
          <div>
            <span className="text-[12px] font-semibold tracking-[0.2em] text-neutral-500 uppercase">Funding & Billing</span>
            <h2 className="mt-3 text-[36px] lg:text-[48px] leading-[1.02] font-bold tracking-tight text-neutral-900">
              Six ways to <span className="font-serif-italic font-normal">fund your care</span>
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-neutral-600 max-w-sm">
              We can help patients understand extended-health, WSIB, and motor-vehicle-accident paperwork.
              Coverage and direct billing depend on each plan, claim, and insurer.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {fundingStreams.map((f) => {
              const Ic = f.icon;
              return (
                <div key={f.name} className="rounded-2xl border border-neutral-200 bg-white p-6 hover:border-[#CA0028] transition-colors">
                  <span className="w-10 h-10 rounded-full bg-neutral-100 grid place-items-center">
                    <Ic size={16} className="text-neutral-900" />
                  </span>
                  <h3 className="mt-4 text-[16px] font-semibold text-neutral-900">{f.name}</h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-neutral-600">{f.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FundingStreams;
